import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, ValidateNested } from "class-validator";
import { NonAdminUsers } from "../../entity";

export class GetAllUserDTO {
  @Expose()
  @ValidateNested()
  @IsArray()
  @Type(() => NonAdminUsers)
  users!: NonAdminUsers[];

  @Expose()
  @IsNumber()
  pageCount!: number;
}
